import { useEffect, useRef } from 'react'
import type { RefObject } from 'react'

export function useLeftRightArrow({
  switchProject,
}: {
  switchProject: (direction: 'left' | 'right') => void
}): RefObject<HTMLElement>[] {
  const leftArrow = useRef<HTMLElement>(null)
  const rightArrow = useRef<HTMLElement>(null)

  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      const htmlTarget = event.target as HTMLElement
      if (htmlTarget.tagName === 'INPUT' || htmlTarget.tagName === 'TEXTAREA') {
        return
      }

      if (event.code === 'ArrowLeft') {
        switchProject('left')
        if (leftArrow.current) {
          leftArrow.current.focus()
        }
      }

      if (event.code === 'ArrowRight') {
        switchProject('right')
        if (rightArrow.current) {
          rightArrow.current.focus()
        }
      }
    }

    document.addEventListener('keydown', onKeyDown)

    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [leftArrow, rightArrow]
}
